import { render, staticRenderFns } from "./AnalyticsUsagePatients.vue?vue&type=template&id=26a3b0db"
import script from "./AnalyticsUsagePatients.vue?vue&type=script&lang=js"
export * from "./AnalyticsUsagePatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports